import Path from '../../../services/paths'
import utils from '../../common/utils'
import CreatePromotionAction from '../../prat_actions/promotion/createPromotionAction'
import {getCookie,safeDraftSuccessDataRevamp} from '../../../util-functions/util-funtions'
import CustomToast from '../../../util-functions/customToast.jsx'

export default class CreatePromotionMiddleware {
     static post_saveDraft(data,type){
        const csrftoken = getCookie('csrftoken');
        return dispatch => {
            dispatch(CreatePromotionAction.newDraft_Request());
            utils.get_token()
            .then(token => {
                fetch(`${Path.BASE_URL}/activity/activity_draft/` , {
                    method: 'POST',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`,
                        'X-CSRFToken': csrftoken
                    },
                    body: JSON.stringify(data)

                })
                .then(res => res.json())
               
                .then(data => {
                    let a_={ ActivityMetadata: {}, PreOpso: {}, guid: "" }
                    a_.guid=data.guid
                    dispatch(CreatePromotionAction.newDraft_Success(a_,type))
                })
                .catch(err => {
                    if(err.message === 'Failed to fetch'){
                        CustomToast('warning', 'Please check your internet connection')
                    }
                    dispatch(CreatePromotionAction.newDraft_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(CreatePromotionAction.newDraft_Failed(err.message))

            })
        }
    };

    static emptyNewdraft(){
        return dispatch => {
            dispatch(CreatePromotionAction.newDraft_Success(undefined));
        }
    };

    static post_updateDraft(data,history,isNewPromotion){
        data['CanSubmit'] = isNewPromotion;
        const csrftoken = getCookie('csrftoken');
        return dispatch => {
            dispatch(CreatePromotionAction.saveDraft_Request ());
            utils.get_token()
            .then(token => {
                fetch(`${Path.BASE_URL}/activity/${data.guid}/activity_draft/` , {
                    method: 'POST',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`,
                        'X-CSRFToken': csrftoken
                    },
                    body: JSON.stringify(data)

                })
                .then(res => res.json())
                .then(data => {
                    if(data?.detail && data?.detail === "Not found."){
                    CustomToast('error', 'Something went wrong with this activity')
                    return history.push('/promotionlist')
                    } else dispatch(CreatePromotionAction.saveDraft_Success(data))
                })
                .catch(err => {
                    dispatch(CreatePromotionAction.saveDraft_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(CreatePromotionAction.saveDraft_Failed(err.message))

            })
        }
    };

     static get_saveDraft(id){
        const csrftoken = getCookie('csrftoken');
        return dispatch => {
            dispatch(CreatePromotionAction.saveDraft_Request ());
            utils.get_token()
            .then(token => {
                fetch(`${Path.BASE_URL}/activity/${id}` , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`,
                        'X-CSRFToken': csrftoken
                    }
                })
                .then(res => res.json())
                .then(data => {
                    // i have shifted this logic in util funtion file in a function name safeDraftSuccessDataRevamp
                    let response = safeDraftSuccessDataRevamp(data)
                    // let a_={ ActivityMetadata: {}, PreOpso: {}, guid: "" }
                    // if(Object.keys(data.ActivityMetadata).length>1){
                    //     a_.ActivityMetadata=data.ActivityMetadata
                    // }else{
                    //     a_.ActivityMetadata={} 
                    // }
                    // a_.guid=data.guid
                    // a_.PreOpso=data.PreOpso
                    // a_.IsExtended=data.IsExtended && data.IsExtended
                    // a_.CanSubmit=data.CanSubmit && data.CanSubmit
                    dispatch(CreatePromotionAction.saveDraft_Success(response))
                })
                .catch(err => {
                    dispatch(CreatePromotionAction.saveDraft_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(CreatePromotionAction.saveDraft_Failed(err.message))

            })
        }
    };
    
   
    static post_createPromotion(apiBody){
        const csrftoken = getCookie('csrftoken');
        return dispatch => {
            dispatch(CreatePromotionAction.createPromotion_Request ());
            utils.get_token()
            .then(token => {
                fetch(Path.BASE_URL + `/activity/${apiBody.key}/pre_opso/` , {
                    method: 'POST',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`,
                        'X-CSRFToken': csrftoken
                    },
                    body: JSON.stringify(apiBody.data)

                })
                .then(res => res.json())
                .then(data => {
                    if(data.message){
                        CustomToast('error', data.message)
                        dispatch(CreatePromotionAction.createPromotion_Failed(data.message))
                        return
                    }
                    if(!data.guid){
                        if(Array.isArray(data)){
                            data.map((e)=>{

                                return CustomToast('error', e)
                            })
                        } else if(data?.response.length===0){
                            CustomToast('error', 'No active MSKUs available for the Product Hierarchy selection')
                            dispatch(CreatePromotionAction.createPromotion_Failed("No active MSKUs available for the Product Hierarchy selection"))

                        }
                    } else if(data?.response){
                        CustomToast('error', data.response)
                        return dispatch(CreatePromotionAction.createPromotion_Success(data))

                    }else{
                        dispatch(CreatePromotionAction.createPromotion_Success(data))
                    }
                })
                .catch(err => {
                    dispatch(CreatePromotionAction.createPromotion_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(CreatePromotionAction.createPromotion_Failed(err.message))

            })
        }
    };

    //-------------------MTFT CREATE PROMOTION PREOPSO
    static post_createPromotionmtfts(apiBody){
        const csrftoken = getCookie('csrftoken');
        return dispatch => {
            dispatch(CreatePromotionAction.createPromotion_Mtfts_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.BASE_URL+`/activity/mtfts/${apiBody.key}/pre_opso/` , {
                    method: 'POST',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`,
                        'X-CSRFToken': csrftoken
                    },
                    body: JSON.stringify(apiBody.data)

                })
                .then(res => res.json())
                .then(data => {
                    dispatch(CreatePromotionAction.createPromotion_Mtfts_Success(data))
                })
                .catch(err => {
                    dispatch(CreatePromotionAction.createPromotion_Mtfts_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(CreatePromotionAction.createPromotion_Mtfts_Failed(err.message))

            })
        }
    };

    // GET ALL ENUM

      static get_allEnum(){
        return dispatch => {
            dispatch(CreatePromotionAction.getallEnum_Request ());
            utils.get_token()
            .then(token => {
                fetch(Path.GET_ALL_ENUM , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    if(Array.isArray(data)){
                        dispatch(CreatePromotionAction.getallEnum_Success(data))
                    } else{
                        CustomToast('error', 'Failed to fetch data please check your network connection')
                        dispatch(CreatePromotionAction.getallEnum_Success(data))
                    }
                })
                .catch(err => {
                    dispatch(CreatePromotionAction.getallEnum_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(CreatePromotionAction.getallEnum_Failed(err.message))

            })
        }
    };   
    
    static post_calculate_preOpso(calculate_data){
        return dispatch => {
            dispatch(CreatePromotionAction.calculate_preOpso_Request());
            utils.get_token()
            .then(token => {
                fetch(Path.BASE_URL+`/activity/${calculate_data._id}/pre_opso/calculate/` , {
                    method: 'POST',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify(calculate_data.PreOpso)

                })
                .then(res => res.json())
                .then(data => {
                    if(!data.guid){
                        if(!data.PreOpso){
                            let err = Object.entries(data)
                            err.map(([key,val]) => {       // eslint-disable-line
                                CustomToast('error', val)
                            });
                        dispatch(CreatePromotionAction.calculate_preOpso_Failed(data))
                        }
                        dispatch(CreatePromotionAction.calculate_preOpso_Failed(data))
                    }else {
                        dispatch(CreatePromotionAction.calculate_preOpso_Success(data))
                    }
                })
                .catch(err => {
                    dispatch(CreatePromotionAction.calculate_preOpso_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(CreatePromotionAction.calculate_preOpso_Failed(err.message))

            })
        }
    };

    static post_preOpso_newProject(activitycode,norm){
        return dispatch => {
            dispatch(CreatePromotionAction.newProject_preOpso_Request());
            utils.get_token()
            .then(token => {
                fetch(`${Path.BASE_URL}/activity/pre_opso/norm_change_msku/?activity_code=${activitycode}&norm_key=${norm}` , {
                    method: 'GET',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                    // body: JSON.stringify(data)

                })
                .then(res => res.json())
                .then(data => {
                    if(!data.io_code){
                        CustomToast('error', data)
                        dispatch(CreatePromotionAction.newProject_preOpso_Failed(data))
                    }else{
                        dispatch(CreatePromotionAction.newProject_preOpso_Success(data))
                    }
                })
                .catch(err => {
                    dispatch(CreatePromotionAction.newProject_preOpso_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(CreatePromotionAction.newProject_preOpso_Failed(err.message))

            })
        }
    };

    static  post_push_to_dwh(_id){
        return dispatch => {
            dispatch(CreatePromotionAction.push_to_dwh_Request(false));
            utils.get_token()
            .then(token => {
                fetch(`${Path.BASE_URL}/activity/${_id}/push_to_dwh/` , {
                    method: 'POST',
                    headers: {
                        "Content-type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(res => res.json())
                .then(data => {
                    let res = Array.isArray(data)
                    if(res === true){
                        CustomToast('error', 'Something went wrong with push to dwh api')
                        dispatch(CreatePromotionAction.push_to_dwh_Failed(data))
                    } else if(res === false){
                        // console.log(data.message,data?.message,data?.api_response?.Import_Status)
                        let checkValue = data?.api_response?.Import_Status
                        if(checkValue !== 'Complete'){
                            CustomToast('error', 'Something went wrong with push to dwh api')
                            dispatch(CreatePromotionAction.push_to_dwh_Failed(data))
                        }
                        else{
                            dispatch(CreatePromotionAction.push_to_dwh_Success(true))
                        }

                    }
                })
                .catch(err => {
                    dispatch(CreatePromotionAction.push_to_dwh_Failed(err.message))
                })
            })
            .catch(err => {
                dispatch(CreatePromotionAction.push_to_dwh_Failed(err.message))

            })
        }
    };

   
}

